module.exports = __webpack_public_path__ + "img/ao.8b6f2ec2.svg";